export default __webpack_public_path__ + "static/media/xoloitzcuintle.ee6db8cb.png";